export const WEEKDAYS = [
  { value: 1, label: 'Mon', long: 'Monday' },
  { value: 2, label: 'Tue', long: 'Tuesday' },
  { value: 3, label: 'Wed', long: 'Wednesday' },
  { value: 4, label: 'Thu', long: 'Thursday' },
  { value: 5, label: 'Fri', long: 'Friday' },
  { value: 6, label: 'Sat', long: 'Saturday' },
  { value: 0, label: 'Sun', long: 'Sunday' }
]

export const BILLING_INTERVALS = [
  { name: 'Every week', value: 'weekly' },
  { name: 'Every 2 weeks', value: 'every_two_weeks' },
  { name: 'Every month', value: 'monthly' }
]

export const GRANT_DAYS = WEEKDAYS.map(day => ({ name: day.long, value: day.long.toLowerCase() }))

export const ordinal = n => {
  const teens = n % 100
  if (teens >= 11 && teens <= 13) return `${n}th`
  return `${n}${{ 1: 'st', 2: 'nd', 3: 'rd' }[n % 10] ?? 'th'}`
}
